import React, { useState, useEffect } from 'react';
import { UrlDev as Url } from '../../../url';
import '../../../entrydoor.css';

// Fetches sizes for the given panel code (e.g. "WG00").
// Returns the full size object to parent via onChange so parent can derive
// lites / location / frame flags from it.

const DoorLiteSize = ({ value = null, onChange, selectedPanel = null, label = 'Lite Size' }) => {
    const [sizes, setSizes]     = useState([]);
    const [selected, setSelected] = useState(value?.value || '');

    useEffect(() => {
        const panel = selectedPanel?.value;
        if (!panel) { setSizes([]); return; }

        fetch(`${Url}/doorlitesize?panel=${encodeURIComponent(panel)}`)
            .then((r) => r.json())
            .then((data) => {
                const list = Array.isArray(data) ? data : [];
                setSizes(list);
                // auto-select first
                if (list.length > 0) {
                    setSelected(list[0].value);
                    onChange(list[0]);
                } else {
                    setSelected('');
                    onChange(null);
                }
            })
            .catch((err) => {
                console.error('DoorLiteSize fetch error:', err);
                setSizes([]);
            });
    }, [selectedPanel?.value]);

    const handleChange = (e) => {
        const v = e.target.value;
        setSelected(v);
        const item = sizes.find((s) => s.value === v) || null;
        onChange(item);
    };

    if (!sizes.length) return null;

    return (
        <div className="a-container">
            <label htmlFor="DoorLiteSize">{label}</label>
            <select id="DoorLiteSize" value={selected} onChange={handleChange}>
                {sizes.map((s) => (
                    <option key={s.id} value={s.value}>{s.value}</option>
                ))}
            </select>
        </div>
    );
};

export default DoorLiteSize;
